// extracted by mini-css-extract-plugin
module.exports = {"cls1":"_404-Main404-module--cls1--3n3JG","cls2":"_404-Main404-module--cls2--AgMHG _404-Main404-module--cls1--3n3JG"};